import React from 'react';
import PropTypes from 'prop-types';

import Box from '../../../../shared/Box';
import Text from '../../../../shared/Text';

const ErrorAlert = ({ title, renderMessage }) => (
  <Box
    padding={16}
    color="rgba(208, 2, 27, 0.1)"
    dangerouslySetInlineStyle={{
      borderRadius: 6,
    }}
  >
    <Text isBold color="#e54751" align="center">
      {title}
    </Text>
    <Text color="#e54751" align="center">
      {renderMessage}
    </Text>
  </Box>
);

ErrorAlert.propTypes = {
  title: PropTypes.string.isRequired,
  renderMessage: PropTypes.oneOf([PropTypes.string, PropTypes.element])
    .isRequired,
};

export default ErrorAlert;
